import podcast from "../../apis/podcast";

export default {
  /////////////////////////////////////////////////////////////////////////////
  ////////////////////////////PODCAST//////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  get_podcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.get_podcast(payload);
        commit("GET_PODCAST", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_podcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.getall_podcast(payload);
        commit("GET_ALL_PODCAST", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_podcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.add_podcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_podcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.update_podcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_podcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.delete_podcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////CATEGORY////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.get_category(payload);
        commit("GET_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.getall_category(payload);
        commit("GET_ALL_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.add_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.update_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_category({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.delete_category(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////EPISODE/////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.get_episode(payload);
        commit("GET_EPISODE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.getall_episode(payload);
        commit("GET_ALL_EPISODE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.add_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.update_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_episode({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.delete_episode(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////HISTORY/////////////////////////////
  /////////////////////////////////////////////////////////////////

  getall_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.getall_history(payload);
        commit("GET_ALL_HISTORY", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.add_history(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_history({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await podcast.update_history(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  // // ///////////////////////////////////////////////////////////////
  // ////////////////////////////FORM/////////////////////////////
  // //////////////////////////////////////////////////////////////

  // getall_form({ commit }, payload) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { data } = await podcast.getall_form(payload);
  //       commit("GET_ALL_FORM", data.data);
  //       resolve(data);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // },

  // add_form({ commit }, payload) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { data } = await podcast.add_form(payload);
  //       resolve(data);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // },

  // update_form({ commit }, payload) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { data } = await podcast.update_form(payload);
  //       resolve(data);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // },

  // delete_form({ commit }, payload) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { data } = await podcast.delete_form(payload);
  //       resolve(data);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // },
};
